export var SELECTION_TYPE = /*#__PURE__*/function (SELECTION_TYPE) {
  SELECTION_TYPE["CURSOR"] = "cursor";
  SELECTION_TYPE["RANGED"] = "ranged";
  SELECTION_TYPE["TEXT"] = "text";
  SELECTION_TYPE["NODE"] = "node";
  SELECTION_TYPE["CELL"] = "cell";
  SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
  return SELECTION_TYPE;
}({});
export var SELECTION_POSITION = /*#__PURE__*/function (SELECTION_POSITION) {
  SELECTION_POSITION["START"] = "start";
  SELECTION_POSITION["MIDDLE"] = "middle";
  SELECTION_POSITION["END"] = "end";
  SELECTION_POSITION["LEFT"] = "left";
  SELECTION_POSITION["RIGHT"] = "right";
  return SELECTION_POSITION;
}({});